import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';

export function ProductForm({ alert, disabled = {}, onSubmit, values = {} }) {
  const { register, handleSubmit } = useForm();

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {alert ? alert : null}
      <Form.Group controlId="productFormProductId">
        <Form.Label>Serial</Form.Label>
        <Form.Control
          defaultValue={values.productId}
          readOnly={disabled.productId}
          name="productId"
          placeholder="Nhập Serial"
          ref={register}
          type="text"
        />
      </Form.Group>
      <Form.Group controlId="productFormCustomerId">
        <Form.Label>Mã Khách Hàng</Form.Label>
        <Form.Control
          defaultValue={values.customerId}
          name="customerId"
          placeholder="Nhập Mã Khách Hàng"
          ref={register}
          type="text"
        />
      </Form.Group>
      <Form.Group controlId="productFormPurchasePrice">
        <Form.Label>Giá Mua</Form.Label>
        <Form.Control
          defaultValue={values.purchasedPrice}
          name="purchasedPrice"
          placeholder="Nhập Giá Mua"
          ref={register}
          type="number"
        />
      </Form.Group>
      <Form.Group controlId="productFormInstallationDate">
        <Form.Label>Ngày Lắp Đặt</Form.Label>
        <Form.Control
          defaultValue={values.installationDate}
          name="installationDate"
          placeholder="Nhập Ngày Lắp Đặt"
          ref={register}
          type="date"
        />
      </Form.Group>
      <Form.Group controlId="productFormWarrantlyExpirationDate">
        <Form.Label>Ngày Hết Hạn Bảo Hành</Form.Label>
        <Form.Control
          defaultValue={values.warrantlyExpirationDate}
          name="warrantlyExpirationDate"
          placeholder="Nhập Ngày Hết Hạn Bảo Hành"
          ref={register}
          type="date"
        />
      </Form.Group>
      <Button type="submit" variant="primary">
        Gửi
      </Button>
    </Form>
  );
}
